module.exports = __webpack_public_path__ + "img/document-accept.ddae350b.svg";